'use strict';

const cardTokens = (theme) => ({
    cardRadius: theme.radiuses.l,
    cardShadow: theme.shadows.default,
});

exports.cardTokens = cardTokens;
//# sourceMappingURL=card.js.map
